<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs5>
          <v-flex xs12>
            <orderSnapShotTable :order="order" :order_eta="order_eta" />
          </v-flex>
          <v-flex xs12>
            <orderPackageManager :order="order" @packageUpdated="packageUpdated" @loadPDF="loadPDF" />
          </v-flex>
          <v-flex xs12>
            <notesManager :order="order" />
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <v-simple-table :fixed-header="true">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        PDF Name
                      </th>
                      <th class="text-left" style="color: #2c6d80;">Date & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="finalPackage.length == 0">
                      <td colspan="2">Package has not been generated yet.</td>
                    </tr>
                    <tr v-for="fPackage in finalPackage" :key="fPackage.id">
                      <td style="cursor: pointer; color: blue;"><span @click="loadPDF(fPackage.file)">{{  fPackage.name }} </span></td>
                      <td>{{ fPackage.created_on | formatDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs7>
          <v-flex xs12>
            <pdfViewer :pdfURL="documentPath" :syncPackages="syncPackages"> </pdfViewer>
          </v-flex>
          <v-flex xs12>
            <v-layout v-if="order.status.slug=='approved-to-sent'">
              <v-flex xs6>
                <div class="text-xs-center" style="text-align: left !important;">
                  <v-btn color="rtsPrimary" dark @click="createFinalPackage" :loading="cfloading">Save PDF</v-btn>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="text-xs-center" style="text-align: right;">
                  <v-btn color="rtsPrimary" dark @click="toSent" :loading="tloading">Send to Client</v-btn>
                </div>
              </v-flex>
              <!-- <v-flex xs1>
                <div class="text-xs-center" style="text-align: center;">
                  <v-btn color="error" dark >Cancel</v-btn>
                </div>
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import pdfViewer from '@/components/pdfViewer.vue'
import orderSnapShotTable from '@/components/orderSnapShotTable.vue'
import orderPackageManager from '@/components/orderPackageManager.vue'
import notesManager from '@/components/notesManager.vue'
import { PATCHORDER, POSTNOTE, GETFINALPACKAGE, CREATEFINALPACKAGE } from '@/store/actions.type'
import Vue from 'vue'

Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'ApprovedToSend',
  components: {
    orderSnapShotTable,
    orderPackageManager,
    notesManager,
    pdfViewer
  },
  data () {
    return {
      selected: [],
      loading: false,
      cfloading: false,
      tloading: false,
      finalPackage: [],
      syncPackages: new Date().getTime()
    }
  },
  props: {
    order: null,
    documentPath: null,
    order_eta: null
  },
  mounted () {
    this.getFinalPackage()
  },
  methods: {
    createFinalPackage () {
      this.cfloading = true
      let finalPackagePayload = {
        order: this.order.id,
        name: `RTS-Order-Summary-${this.order.id}-${new Date().getTime()}.pdf`
      }
      this.$store
        .dispatch(CREATEFINALPACKAGE, finalPackagePayload)
        .then(response => {
          alert('Package created!!!')
          this.cfloading = false
          this.getFinalPackage()
        })
    },
    packageUpdated () {
      this.syncPackages = new Date().getTime()
    },
    getFinalPackage () {
      let payload = {
        order__id: this.order.id
      }
      this.$store
        .dispatch(GETFINALPACKAGE, payload)
        .then(response => {
          this.finalPackage = response.results
        })
    },
    toSent () {
      this.tloading = true
      let payload = {
        id: this.order.id,
        status: 8
      }
      this.$store.dispatch(PATCHORDER, payload).then(response => {
        let noteCreatedBy = JSON.parse(window.localStorage.getItem('auth')).user_data
        this.order = response
        this.loading = false
        this.tloading = false
        let assignerNotePayload = {
          note: `Order moved to Sent Stage by ${noteCreatedBy.username}`,
          order: this.order.id,
          type: 'Order'
        }
        this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
          console.log(noteResponse)
          this.$emit('updateOrder', this.order)
        })
      })
    },
    loadPDF (file) {
      this.documentPath = null
      this.documentPath = file
    }
  }
}
</script>

<style>
body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 96%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}
</style>
